// eslint-disable-next-line import/no-cycle
import { trackPromise } from 'react-promise-tracker';
import api from '../api/api';

const SessionService = {
  checkSession: (page: string) =>
    trackPromise(api.post(`/rest/check/session/${page}/`)),
  closeSession: (url: string) => trackPromise(api.post(url)),
  checkAppSession: () =>
    trackPromise(api.post(`/rest/user/config/get/appSession`)),
};

export default SessionService;
